var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolSmokerOnGroundFieldObs = function SvgFiremapSymbolSmokerOnGroundFieldObs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#firemap-symbol-smoker-on-ground-field-obs_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    fillRule: "evenodd",
    d: "M20 16.957H4l1.523-2.836 5.086.415 1.239-3.034h2.925l-.99 3.159 4.827-.212zM10.921 6.917v1.622l.68-1.44 1.095 1.089-.597-1.472h1.612l-1.395-.64 1.057-1.085-1.477.574V4l-.591 1.472-1.148-1.178.645 1.438H9.218l1.408.654-1.157 1.13zM14.44 9.453l-.626.848.869-.579.214.98.236-.98.853.579-.569-.848.963-.17-.962-.276.62-.853-.941.615-.13-1.104-.23 1.104-.923-.677.625.915-1.155.177zM6.681 8.274l.3 1.153-1.15-.19.963.678-.963.646 1.15-.307-.187 1.187.627-.999.625.93-.24-1.118 1.149.188-.983-.584.983-.717-1.2.286.291-1.153-.653.962z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    fillRule: "evenodd",
    d: "m16.504 13.333-.124.784.433-.676.422.626-.12-.734.748.108-.677-.414.677-.462-.749.16.121-.806-.422.646-.511-.646.202.806-.822-.16.698.453-.698.453zM9.013 12.781l.35-.704v.782l.699-.232-.57.502.695.378-.78-.03.317.752-.583-.593-.326.65v-.74l-.667.253.506-.532-.7-.341h.803l-.298-.714z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0 2c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "firemap-symbol-smoker-on-ground-field-obs_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgFiremapSymbolSmokerOnGroundFieldObs;